<template>
  <button
    :aria-label="$t('SIDEBAR.NOTIFICATIONS')"
    class="relative flex items-center justify-center w-11 h-11 rounded-xl outline-none transition-colors duration-200 ease-out focus-visible:ring-2 focus-visible:ring-accent-mint/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-ink"
    :class="
      isNotificationPanelActive
        ? 'bg-woot-25 text-accent-mint hover:bg-woot-50 dark:bg-mint/10 dark:hover:bg-mint/[0.16]'
        : 'text-slate-600 hover:bg-slate-50 hover:text-slate-800 dark:text-slate-300 dark:hover:bg-white/[0.06] dark:hover:text-slate-50'
    "
    @click="openNotificationPanel"
  >
    <!-- Same rail as the nav items: one language for "you are here". -->
    <span
      aria-hidden="true"
      class="absolute inset-y-0 w-[3px] h-6 my-auto -start-1.5 md:-start-3.5 rounded-e-full bg-accent-mint transition-transform duration-200 ease-out"
      :class="isNotificationPanelActive ? 'scale-y-100' : 'scale-y-0'"
    />
    <fluent-icon icon="alert" />
    <span
      v-if="unreadCount"
      class="absolute -top-0.5 -end-0.5 min-w-[1.125rem] px-1 leading-[1.125rem] text-center rounded-full text-xxs font-semibold bg-mint text-ink"
    >
      {{ unreadCount }}
    </span>
  </button>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('open-notification-panel');
      }
    },
  },
};
</script>
